var map = {
	"./changepass.svg": "5710",
	"./chevron-down.svg": "7bb8",
	"./deleteacc.svg": "b43b",
	"./dollar-white.svg": "e4fe",
	"./dollar.png": "75a4",
	"./hashtag-white.svg": "9e0c",
	"./hashtag.png": "c752",
	"./logout.png": "be26",
	"./manage.png": "62d9",
	"./my-transaction.svg": "32d3",
	"./my-transactions.png": "1f57",
	"./notifi.png": "54ba",
	"./notify-white.svg": "712b",
	"./notify.png": "c405",
	"./personal-white.svg": "ad09",
	"./personal.png": "a37a",
	"./recurring.png": "4e6b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7af3";